import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { VehicleBooking } from './vehicle-booking';

@Injectable({ providedIn: 'root' })
export class VehicleBookingService {

	statuses: any = [
		{ value: 0, name: 'Booked' },
		{ value: 1, name: 'Cancelled' },
		{ value: 2, name: 'Requested' },
		{ value: 3, name: 'Unavailable' }
	];

	vehicles: any = [
		{ value: 'CCAR', name: 'Compact', price: 0},
		{ value: 'ICAR', name: 'Intermediate', price: 11},
		{ value: 'SCAR', name: 'Standard', price: 16},
		{ value: 'IFAR', name: 'Intermediate SUV', price: 24},
		{ value: 'FCAR', name: 'Full Size', price: 21},
		// { value: 'LCAR', name: 'Luxury'},
		// { value: 'JP2D', name: 'Jeep'},
		{ value: 'STAR', name: 'Convertible', price: 29},
		{ value: 'MVAR', name: 'Minivan', price: 39},
		{ value: 'SFAR', name: 'Standard SUV', price: 39},
		{ value: 'RFAR', name: 'Deluxe SUV', price: 46},
		{ value: 'FFAR', name: 'Premium SUV', price: 69},
		{ value: 'PFAR', name: 'Premium SUV XL', price: 79},
	];


	agencies: any = [
		{ value: 'Avis', name: 'Avis' },
		{ value: 'Budget', name: 'Budget' },
		{ value: 'National', name: 'National' },
		{ value: 'Enterprise', name: 'Enterprise' },
		{ value: 'Alamo', name: 'Alamo' },
		{ value: 'Hertz', name: 'Hertz' },
		{ value: 'Dollar', name: 'Dollar' },
	];

	pickupDrops: any = [
		{ value: 'OGG', name: 'Kahului (OGG), Maui' },
		// { value: 'JHM', name: 'Kapalua' },
		{ value: 'HNL', name: 'Honolulu (HNL), Oahu' },
		{ value: 'KOA', name: 'Kona (KOA), Big Island' },
		// { value: 'LIH', name: 'Kauai' },
	];



	constructor
		(
			private http: HttpClient,
			private alertService: AlertService
		) { }

	urlEndpoint = 'vehicle-bookings';

	add(vehicleBooking: VehicleBooking): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(vehicleBooking));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, vehicleBooking);
	}

	update(vehicleBooking: VehicleBooking): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, vehicleBooking);
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
